import { render, staticRenderFns } from "./imgcardList.vue?vue&type=template&id=2b3fff43&"
import script from "./imgcardList.vue?vue&type=script&lang=js&"
export * from "./imgcardList.vue?vue&type=script&lang=js&"
import style0 from "./imgcardList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports